/**
 * Project image hooks (Phase 10c.9)
 *
 * Manages per-project cover image override stored in Firestore.
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { toast } from 'sonner';

export function useProjectCoverImage(projectId: string | undefined) {
  return useQuery({
    queryKey: ['project-cover-image', projectId],
    queryFn: () => api.projects.getCoverImage(projectId!),
    enabled: !!projectId,
    select: (data) => data.cover_image_base64,
  });
}

export function useUpdateProjectCoverImage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ projectId, coverImage }: { projectId: string; coverImage: string | null }) =>
      api.projects.updateCoverImage(projectId, coverImage),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['project-cover-image', variables.projectId] });
      toast.success(variables.coverImage ? 'Cover image updated' : 'Cover image removed');
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to update cover image');
    },
  });
}
